module.exports = __webpack_public_path__ + "img/PL08985.e4b27ddc.png";